import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import './i18n/i18n';
import { initDocumentMeta } from './i18n/documentMeta';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { inject as injectAnalytics } from '@vercel/analytics';
import { ThemeProvider } from './context/ThemeContext';
import { ContactProvider } from './context/ContactContext';

initDocumentMeta();
injectAnalytics();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <ContactProvider>
          <App />
        </ContactProvider>
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
